import React from "react";

const StateAndProvinceContext = React.createContext({});

export default StateAndProvinceContext;
